export const fullCapsText = (text: string) => {
  if (!text) return ""; //handle null values
  return text.toUpperCase();
};

export const capFirstLetter = (text: string) => {
  if (!text) return ""; //handle null values
  let textArr = text.split(" ");
  let newText = "";
  textArr.forEach(word => {
    newText += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + " ";
  });
  return newText.trim();
};
